import {useEffect} from "react";

import {Snapshot, useSnapshot} from "valtio";

import {IValtioModel} from "@/shared/models/base-model.interface";

export function useModelSnapshot<T extends object>(model: T & IValtioModel): Snapshot<T> {
    const snapshot = useSnapshot<T>(model);
    useEffect(() => {
        if (model?.init) {
            void model.init();
        }

        return () => {
            if (model?.dispose) {
                void model.dispose();
            }
        };
    }, [model]);
    return snapshot;
}
